import { useParams, useNavigate } from 'react-router-dom';
import {
  Box, 
  Button, 
  IconButton,
  Paper, 
  
  Table, 
  TableBody,
  TableCell, 
  TableHead, 
  TableRow,

  Toolbar, 
  Typography,
  Tooltip
} from '@mui/material';

import LockIcon from '@mui/icons-material/Lock';
import LockOpenIcon from '@mui/icons-material/LockOpen';

import {
  useFetchTournamentsQuery, 
  useCopyTournamentMutation, 
  useToggleTournamentStatusMutation,
} from '../../store/tournament/TournamentApi';



/*
 * Darstellen der unterschiedlichen Bearbeitungsmöglichkeiten für das Turnier...
 */
export default function TournamentAdmin()
{
  // Als Parameter wird das aktuelle Jahr mit übergeben (als Teil des Routings)
  const {year} = useParams();
  const currentYear = parseInt(year);
  const navigate = useNavigate();

  // schnappen wir uns als erstes alle vorhandenen Turniere
  const { data : tournaments } = useFetchTournamentsQuery();
  // Zugriff auf die Funktion des Kopierens der Turniere
  const [copyTournament] = useCopyTournamentMutation();
  const [toggleTournamentStatus] = useToggleTournamentStatusMutation();

  // Prüfen, ob es das nächste Jahr schon gibt, oder welches Jahr wir jetzt erstellen müssten: 
  const nextTournament  = () => 
  {
    // Array mit allen aktuellen Jahren erstellen
    const years = new Set(tournaments?.map(t => t.year) ?? []);
    // Aktuelles Jahr ermitteln - wir starten bei der Suche bei dem aktuellen Jahr
    let year = new Date().getFullYear();
    // So lange weitermachen, bis wir das aktuelle Jahr haben
    while (years.has(year)) year++;

    // jetzt haben wir es gefunden
    return year;
  }


  // Reagieren und Durchführen des Kopierens eines Wertes in ein neues
  // Turnier (sofern dieses noch nicht existiert...)
  const handleCopy = async () => 
  {
      try {
        const result = await copyTournament({ year_copy_from: currentYear, year_copy_to: nextTournament() }).unwrap();
        navigate(`/${result.year}/admin/tournament`);
      } catch (err) {
        console.error(err);
      }
  };


  // Zwischen geschlossenen und offenen Status des Turniers wechseln
  const handleToggleStatus = async (year) => 
  {
    try 
    {
      await toggleTournamentStatus(year).unwrap();
      
    }
    catch (error)
    {
      console.error(error);
    }
  };


  return (
    <Box sx={{ p: 2 }}>
      <Toolbar>
        <Typography variant="h5" sx={{ flexGrow: 1 }}>
          Turnierübersicht
        </Typography>        
        <Button variant="outlined" onClick={handleCopy}>
          Aktuelles Turnier {currentYear} nächste Jahr ({nextTournament()}) kopieren
        </Button>
            
      </Toolbar>

      <Paper sx={{ p: 2, mt: 1 }}>
        <Typography variant="h6" sx={{ mb: 1 }}>Turnierübersicht</Typography>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell>Jahr</TableCell>
              <TableCell>Name</TableCell>
              <TableCell>Zeitraum</TableCell>
              <TableCell align="center">Status</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {tournaments?.map(tournament => (
              <TableRow key={tournament.year}>
                <TableCell>{tournament.year}</TableCell>
                <TableCell>{tournament.name}</TableCell>
                <TableCell>{tournament.dateFrom} – {tournament.dateUpto}</TableCell>
                <TableCell align="center">
                  <Tooltip title={tournament.closed ? 'Turnier öffnen' : 'Turnier schließen'}>
                    <IconButton onClick={() => handleToggleStatus(tournament.year)} size="small">
                      {tournament.closed
                        ? <LockIcon color="error" />
                        : <LockOpenIcon color="success" />}
                    </IconButton>
                  </Tooltip>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </Paper>

    </Box>
  );
}
 
